const ADMIN_IDS = [1, 13, 44, 104, 187, 244, 247, 87, 284, 258]

export function isAdmin (userId) {
  return ADMIN_IDS.includes(Number(userId))
}
